import EmotionalInertia from './EmotionalInertia';
export default EmotionalInertia;
